<template>
<div>
  <div class="product-content--size">
    <h3>{{ $t("konf_ChooseYourSize") }}</h3>
  </div>
  <div class="product-content--size-list">
    <ul class="size-list"
        v-if="getSizes.length > 0"
    >
      <li class="size-list-elem"
          v-for="size in getSizes"
          :key="size.size"
          :data-id="size.size"
          :class="{ active: currentSize === size.size }"
          @click="setSizeForShopitem(size.size)"
      >
        <span class="size-block">{{ size.name }}</span>
      </li>
    </ul>
    <div class="error" v-show="sizeMissing">{{ $t("konf_groesse_waehlen") }}</div>
  </div>
</div>
</template>

<script lang = "ts">
import { type Ref, ref, computed } from "vue";
import { type ShopItem, useShopItems } from "~/store/shopItemsStore";

export default {
        name: "ProductViewCurrentSizes",
        props: {
          product: Object,
          sizeMissing: Boolean,
          selectedColorVariant: Number
        },
        setup(props, context) {
          const shopItems = useShopItems();
          const currentSize = ref(0);
          const item = props.product as ShopItem;
          const getSizes = ref(getPossibleSizesForProduktFarbe());

          watch(() => props.selectedColorVariant, (newValue, oldValue) => {
            getSizes.value = getPossibleSizesForProduktFarbe();
          });


          function setSizeForShopitem(sizeVal){
            context.emit('resetErrors');
            currentSize.value = sizeVal;
            shopItems.setSizeForShopitem({saveID: item.saveID, value: sizeVal});
          }
          function getPossibleSizesForProduktFarbe(){
            if(item.produktFarben.length === 0){
              return item.possibleSizes.filter((item, index) => index !== 0);
            }
            const saveID = props.selectedColorVariant>-1 ? props.selectedColorVariant : item.saveID.toString();
            const selectedProduct = item.produktFarben.filter(obj => obj.farbvariantenSaveID === saveID)[0];
            if(selectedProduct === undefined){
              return item.possibleSizes.filter((item, index) => index !== 0);
            }
            return selectedProduct.possibleSizes.filter((item, index) => index !== 0);
          }

          return {
            currentSize,
            getSizes,
            setSizeForShopitem
          }
        }
    }
</script>

<style lang="scss" scoped>

@use "~/assets/scss/settings/_config.scss" as *;

.product-content--size {
  h3 {
    display: inline-block;
    font-weight: 600;
    font-size: 14px;
  }
  a {
    display: inline-block;
    padding-left: 5px;
    color: $color-blue;
    font-size: 15px;
    font-weight: 600;
  }
}

.product-content--size-list {
  margin-bottom: 0px;
  padding-top: 10px;
  width: 400px;
  max-width: 100%;

  .size-list {
    display: flex;
    flex-wrap: wrap;
    column-gap: 15px;

    .size-list-elem {
      width: calc(25% - 15px);
      margin-bottom: 15px;

      &.active {
        background: rgba($color-grey, .5);
      }

      .size-block {
        border: 1px solid $color-grey;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 30px;
        cursor: pointer;
        text-align: center;
        padding: 0 5px;
        line-height: 12.5px;
      }
    }
  }
}

</style>
